<template>
  <div id="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-sm-3">
          <div class="section">
            <h6>Öppettider växel</h6>
            <p>
              Vardagar 8:00-17:00<br />
              Lunch 12:00-13:00
            </p>
          </div>
          <div class="section">
            <h6>Besöksadress</h6>
            <p>
              Hövdingegatan 1<br />
              82 42 Hudiksvall
            </p>
          </div>
          <div class="section">
            <h6>Postadress</h6>
            <p>
              Box 1149<br />
              824 14 Hudiksvall
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-3">
          <div class="section">
            <h6>Kontakta oss</h6>
            <p>
              <a href="#">slack</a><br />
              <a href="#">skype</a><br />
              <a href="#">e-post</a>
            </p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-5">
          <div class="section">
            <h6>Vill du ha vårt nyhetsbrev?</h6>
            <newsletter-signup></newsletter-signup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsletterSignup from '@/components/NewsletterSignup.vue'

export default {
  name: 'Footer',
  components: {
    'newsletter-signup': NewsletterSignup
  }
}
</script>

<style lang="scss">
@import "./src/util";

#footer {
  border-top: 1px solid $cl_light_grey;
  @include if-wider-than(767){
    padding: 111px 15px 148px 15px;
  }

  @include if-wider-than(991){
    padding: 111px 49px 148px 49px;
  }

  @include if-wider-than(1200){
    padding: 111px 100px 148px 200px;
  }

  .section {
    h6 {
      font-size: 18px;
      color: #fff;
      margin: 0px;
    }
    p {
      font-size: 18px;
      color: $cl_lighter_grey;
      margin-bottom: 46px;
    }
    a {
      color: $cl-lighter_grey;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue